// Central mock/static branding data for DoctorLab & Diagnostics
// Only STATIC UI constants live here now. Dynamic data (tests, packages, blogs, brand)
// is fetched from the backend via src/lib/api.js.

export const LOGO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/lk9a1hdz_logo_basic%20%281%29.webp";

export const BRAND = {
  name: "DoctorLab & Diagnostics",
  tagline: "Pathology Lab & Diagnostic Centre in Ranchi. Reliable Diagnostics. Clearer Health Decisions.",
  phone: "+916207900135",
  phone2: "+919155395365",
  whatsapp: "+916207900135",
  email: "care@doctorlabdiagnostics.com",
  hours: "Mon–Sun · 7:30 AM – 9:00 PM",
  established: 2011,
  logoUrl: LOGO_URL,
  reportsDelivered: "",
  homeVisits: "",
  tests: "",
  packages: "",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about-doctorlab" },
  { label: "Tests", to: "/tests" },
  { label: "Health Packages", to: "/health-packages" },
  { label: "Home Collection", to: "/home-sample-collection-ranchi" },
  { label: "Locations", to: "/locations" },
  { label: "Health Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const TRUST = [
  { title: "Local Diagnostic Lab", sub: "Based in Lalpur, Ranchi" },
  { title: "Patient-Friendly", sub: "Clear info, warm service" },
  { title: "Wide Test Menu", sub: "Common pathology tests" },
  { title: "Digital Reporting", sub: "Report via digital system" },
  { title: "Home Collection", sub: "In select Ranchi localities" },
  { title: "Established", sub: "Serving since 2011" },
];

export const FAQS = [
  { q: "Where is the nearest pathology lab near me in Ranchi, Jamshedpur or Ghatshila?", a: "DoctorLab & Diagnostics operates 17 collection centres across Ranchi (Lalpur, Harmu, Morabadi, Bariatu, Doranda, Kanke, Hinoo, Ratu Road), Jamshedpur (Sakchi, Bistupur, Mango, Sonari, Kadma, Golmuri, Telco, Adityapur) and Ghatshila plus East Singhbhum (Dhalbhumgarh, Chakulia, Musabani, Jadugoda, Galudih, Baharagora). Book a test online or call our 24x7 helpline." },
  { q: "How do I book a blood test with home collection in Jharkhand?", a: "You can book online from any test or package page, call our 24x7 helpline, or WhatsApp us. Home collection is available across Ranchi, Jamshedpur, Ghatshila and nearby localities in East Singhbhum – free above ₹500." },
  { q: "How quickly will I receive my pathology report?", a: "Most routine tests are delivered the same evening. Special tests take 24–48 hours. You’ll receive reports via WhatsApp, email and the patient portal." },
  { q: "Is DoctorLab an NABL-accredited pathology lab?", a: "Our main labs in Ranchi and Jamshedpur operate under NABL-aligned quality protocols with third-party proficiency testing." },
  { q: "Do you accept cashless corporate & insurance requests?", a: "Yes, we work with major TPAs and corporate health partners across Jharkhand. Please contact our helpline to confirm empanelment." },
  { q: "Can I download old reports online?", a: "Yes. Use the Download Report page with your registered phone number – reports are archived for 5 years and accessible on WhatsApp, email and the patient portal." },
];

// Fallback data used only if the backend API is unavailable (soft-fallback).
export const POPULAR_TESTS = [
  { id: "cbc", name: "Complete Blood Count (CBC)", short: "Screens overall health & detects infections", price: 350, mrp: 500, fasting: false, tat: "Same day", category: "cbc" },
  { id: "hba1c", name: "HbA1c (Glycated Haemoglobin)", short: "3-month average blood sugar level", price: 490, mrp: 700, fasting: false, tat: "Same day", category: "diabetes" },
  { id: "tsh", name: "Thyroid Profile (T3, T4, TSH)", short: "Detects thyroid disorders", price: 550, mrp: 800, fasting: false, tat: "Same day", category: "thyroid" },
  { id: "lipid", name: "Lipid Profile", short: "Cholesterol & heart-risk assessment", price: 599, mrp: 900, fasting: true, tat: "Same day", category: "heart" },
];

export const CATEGORIES = [
  { id: "diabetes", name: "Diabetes", count: 24, color: "blue" },
  { id: "thyroid", name: "Thyroid", count: 18, color: "teal" },
  { id: "heart", name: "Heart Health", count: 22, color: "purple" },
];

export const PACKAGES = [
  { id: "full-body-basic", name: "Full Body Checkup – Basic", tests: 55, price: 999, mrp: 2400, tag: "Most Popular", highlights: ["CBC", "Diabetes", "Lipid"], for: "Adults 25+", fasting: true },
];

export const CITIES = [
  { id: "ranchi", name: "Ranchi", tagline: "Capital of Jharkhand · 8 collection centres", localities: ["Lalpur", "Harmu", "Morabadi", "Bariatu", "Doranda", "Kanke", "Ashok Nagar", "Hinoo", "Ratu Road"], address: "Main Lab: Lalpur Chowk, Ranchi – 834001" },
  { id: "jamshedpur", name: "Jamshedpur", tagline: "Steel City · 6 collection centres", localities: ["Sakchi", "Bistupur", "Mango", "Sonari", "Kadma", "Golmuri", "Telco", "Adityapur"], address: "Main Lab: Bistupur Main Road, Jamshedpur – 831001" },
  { id: "ghatshila", name: "Ghatshila", tagline: "East Singhbhum · 3 collection centres", localities: ["Ghatshila", "Dhalbhumgarh", "Chakulia", "Musabani", "Jadugoda", "Galudih", "Baharagora"], address: "Main Centre: NH-33, Near Rankini Mandir, Ghatshila – 832303" },
];

export const REVIEWS = [
  { id: "r1", name: "Anjali Sinha", city: "Ranchi", rating: 5, text: "Home collection was on time and the phlebotomist was very gentle. Reports came the same evening on WhatsApp." },
];

export const BLOGS = [
  { id: "understanding-hba1c", title: "Understanding HbA1c: What Your 3-Month Sugar Average Really Means", category: "Diabetes", date: "2025-06-18", author: "Dr. Meera Prasad", read: "6 min read", excerpt: "HbA1c reflects your average blood sugar over the past 3 months." },
];

// Image assets — real DoctorLab & Diagnostics photos (Lalpur, Ranchi).
// Stock imagery is intentionally NOT used here per SEO / trust guidelines.
export const HERO_IMAGE = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/1w5vs6i2_ADVANCED%20HIGHTECH%20MACHINE%20DOCTORLAB%20AUTOMATED%20SYSTEMS.jpeg";
export const IMG_LAB_TECH = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/1w5vs6i2_ADVANCED%20HIGHTECH%20MACHINE%20DOCTORLAB%20AUTOMATED%20SYSTEMS.jpeg";
export const IMG_HOME_COLLECT_1 = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/ulpefsfg_INHOUSE%20SAMPLE%20PROCESSING%20AND%20BLOOD%20COLLECTION%20IN%20RANCHI.jpeg";
export const IMG_HOME_COLLECT_2 = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/mxil9l4o_DOCTORLAB%20AND%20DIAGNOSTICS%20COLLECTION%20TESTING%20LAB%20RANCHI.jpeg";
export const IMG_CHECKUP = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/ulpefsfg_INHOUSE%20SAMPLE%20PROCESSING%20AND%20BLOOD%20COLLECTION%20IN%20RANCHI.jpeg";
export const IMG_LAB_ALT = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/mxil9l4o_DOCTORLAB%20AND%20DIAGNOSTICS%20COLLECTION%20TESTING%20LAB%20RANCHI.jpeg";
export const IMG_JUSTDIAL_BADGE = "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/my3rtuqx_AMITABH%20BACCHAN%20ENDORSING%20DOCTORLAB%20AND%20DIAGNOSTICS%20JUSTDIAL%20JD.jpeg";
